import { ListItem } from '@cko/primitives';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { menuItemHoverStyle } from '../../SideNavMenu.styles';

export const StyledSideNavLevelTwoNavLink = styled(NavLink)`
  color: var(--action-text-secondary);
  font: var(--body-xs);
  text-decoration: none;
`;

export const StyledBlockedLink = styled.div`
  font: var(--body-xs);
  color: var(--control-text-disabled);
`;

export const StyledBaseListItem = styled(ListItem)`
  background-color: var(--base-bg-primary);
  padding: var(--layout-seed) var(--layout-soapbar);
`;

export const StyledSideNavLevelTwoListItem = styled(StyledBaseListItem)<{
  $isActiveRoute?: boolean;
}>`
  background-color: var(--base-bg-primary);
  padding: var(--layout-seed) var(--layout-soapbar);

  ${menuItemHoverStyle}

  ${({ $isActiveRoute }) => $isActiveRoute && activeLevelTwoLinkStyle}
`;

const activeLevelTwoLinkStyle = css`
  border-left: var(--border-b-seed) solid var(--control-border-hover);
  margin-left: -1px;

  ${StyledSideNavLevelTwoNavLink} {
    color: var(--action-text-visited);
    font: var(--body-xs-emphasis);
  }
`;
